/**
 * Edge 神经语音的本机缓存（2026-10-31，老板：用户多了服务器带宽怎么办）。
 *
 * 同一句话、同一个音色、同样的语速音调，第一次从服务器（/api/tts）拿 mp3，存进浏览器的 Cache Storage，
 * 之后再念就直接从这台电脑上读，不再问服务器。提醒语大多是重复的（「熔断了」「该起来活动了」），这一层省掉大部分流量。
 * 最多存 200 句（一句 15 到 25 KB，加起来 5 MB 以内），多了删最早的。浏览器不支持就当没有缓存。
 */
const CACHE = 'jysh-tts-v1';
const MAX = 200;

export const ttsCacheKey = (voice: string, rate: number, pitch: number, text: string): string => `${voice}|${rate}|${pitch}|${text}`;

async function keyUrl(k: string): Promise<string> {
  const d = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(k));
  const hex = [...new Uint8Array(d)].map(b => b.toString(16).padStart(2, '0')).join('');
  return location.origin + '/_tts-cache/' + hex;
}

/** 本机有没有这一句。没有、或者浏览器不支持，都是 null */
export async function cachedTts(k: string): Promise<Blob | null> {
  try {
    if (typeof caches === 'undefined') return null;
    const r = await (await caches.open(CACHE)).match(await keyUrl(k));
    return r ? await r.blob() : null;
  } catch {
    return null;
  }
}

/** 存一句，超过 200 句就删最早的 */
export async function saveTts(k: string, blob: Blob): Promise<void> {
  try {
    if (typeof caches === 'undefined') return;
    const c = await caches.open(CACHE);
    await c.put(await keyUrl(k), new Response(blob, { headers: { 'content-type': 'audio/mpeg' } }));
    const keys = await c.keys();
    for (const old of keys.slice(0, Math.max(0, keys.length - MAX))) await c.delete(old);
  } catch { /* 存不进去就算了：下次再从服务器拿 */ }
}
